import { createContext } from 'react';
import { SplitActionSharedProps } from './SplitAction.types';

export const SplitActionContext = createContext<SplitActionSharedProps>({});
